import StudyList from "../components/StudiesList";

function StudiesPage() {
  return (
    <>
      <StudyList />
    </>
  );
}

export default StudiesPage;
